import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as clevertapCustomersLoyalty from 'clevertap/customers/loyalty';
import ReactPlayer from 'react-player';
import styles from './Introduction.css';

class Introduction extends Component {
  componentDidMount() {
    clevertapCustomersLoyalty.loyaltyStart();
  }

  render() {
    return (
      <div className={`row ${styles['body-container']}`}>
        <div className={`row ${styles['row-padding']}`}>
          <div className="col-sm-6 col-md-6">
            <ReactPlayer
              url="https://www.youtube.com/watch?v=iwIe4tpGK7Q&feature=youtu.be"
              height="313px"
              width="100%"
              playing={false}
              controls
              onPlay={this._onVideoPlay}
            />
          </div>
          <div className="col-sm-5 col-md-5">
            <div className={styles.title}>
              <p>
                Turn Your <b>Customer</b>
              </p>
              <p>
                Into <b>Loyalty Member</b>
              </p>
            </div>
            <hr className={styles.line} />
            <p className={styles['body-content']}>
              Set up your Loyalty Program today and keep your customers coming
              back for repeat purchases!
            </p>
            <br />
            <p className={styles['body-content']}>
              One Program for all outlets.
            </p>
            <button
              onClick={this._onClickTryLoyalty}
              className={`btn btn-success btn-block ${styles['create-button']}`}
            >
              TRY IT NOW <i className="fa fa-arrow-right" />
            </button>
          </div>
        </div>
        <div className={`row ${styles['row-padding']}`}>
          <div className="col-sm-6 col-md-6">
            <p className={styles['body-content']}>
              <i className={`fa fa-question-circle-o fa-2x ${styles.icon}`} />
              If you need more help, you can go to&nbsp;
              <a
                href="https://mokaposhelp.zendesk.com/hc/en-us"
                target="_blank"
                className={styles.link}
                onClick={this._onClickKnowledgeCenterLink}
              >
                KNOWLEDGE CENTER
              </a>
            </p>
            <p className={styles['body-content']}>
              <i
                className={`fa fa-question-circle-o fa-2x ${styles.icon} ${styles.hidden}`}
              />
              Or you can read articles about Loyalty Program from&nbsp;
              <a
                href="https://blog.mokapos.com/2018/01/10/meningkatkan-penjualan-melalui-loyalty-program"
                target="_blank"
                className={styles.link}
                onClick={this._onClickLoyaltyBlogLink}
              >
                OUR BLOG
              </a>
            </p>
          </div>
          <div className="col-sm-5 col-md-5">
            <div
              className={`alert alert-warning ${styles['warning-container']}`}
            >
              <div>
                <span>
                  <b>Compatibility:</b>{' '}
                  <i>
                    Requires Moka App v7.0 (android
                    <br />
                    tablet) or v12.8 (iOS) or newer.
                  </i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onVideoPlay = () => {
    clevertapCustomersLoyalty.loyaltyVideoStart();
  };

  _onClickKnowledgeCenterLink = () => {
    clevertapCustomersLoyalty.knowledgeCenterLinkClick();
  };

  _onClickLoyaltyBlogLink = () => {
    clevertapCustomersLoyalty.loyaltyBlogLinkClick();
  };

  _onClickTryLoyalty = () => {
    this.props.goToSubscribeView();
  };
}

Introduction.propTypes = {
  goToSubscribeView: PropTypes.func.isRequired,
};

export default Introduction;
